const NotFoundPage = () => {
  return (
    <div className="w-full flex flex-1 mt-30">
      <div className="m-auto flex justify-center items-center flex-col">
        <h1 className="mt-10 mb-4">Sorry, this page can't be found.</h1>
        <p>
          This page doesn't exist. It may be moved or the URL may be incorrect.
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
